import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useHistory } from 'react-router-dom';
import './Login.css';
import Image from "../images/logo.png";



const Login = () => {
  const [credentials, setCredentials] = useState({
    phone: '',
    password: '',
    country_code: '+91'
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { login } = useAuth();
  const history = useHistory();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Basic validation
    if (!credentials.phone || !credentials.password) {
      setError('Please fill in all fields');
      setIsLoading(false);
      return;
    }

    // Add phone number validation
    if (credentials.phone.length < 10) {
      setError('Please enter a valid phone number');
      setIsLoading(false);
      return;
    }

    try {
      const result = await login(credentials);
      
      console.log('🔐 Login result:', result); // Debug log
      
      if (result.success) {
        console.log('✅ Login successful, redirecting to /'); // Debug log
        // Redirect to main application
        history.push('/');
      } else {
        console.log('❌ Login failed:', result.message); // Debug log
        setError(result.message);
      }
    } catch (error) {
      console.log('💥 Login error:', error); // Debug log
      setError('An unexpected error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img src={Image} alt="TickleRight" className="login-logo" />
          <h1 className="login-title">Sign In</h1>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <div className="phone-input-container">
              <select 
                name="country_code" 
                value={credentials.country_code}
                onChange={handleChange}
                className="country-code-select"
                disabled={isLoading}
              >
                <option value="+91">INDIA (+91)</option>
                <option value="+1">USA (+1)</option>
                <option value="+44">UK (+44)</option>
              </select>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={credentials.phone}
                onChange={handleChange}
                placeholder="9999999999"
                required
                disabled={isLoading}
                maxLength="15"
                className="phone-input"
              />
            </div>
          </div>

          <div className="form-group">
            <div className="password-input-container">
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                placeholder="••••"
                required
                disabled={isLoading}
                className="password-input"
              />
              {/* <span className="password-toggle">👁</span> */}
            </div>
          </div>

          {/* <div className="forgot-password">
            <a href="#" className="forgot-link">Forgot Password ?</a>
          </div> */}

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;